import React from 'react';
import { SvgIcon } from 'material-ui';

const UsageLimits = (props) => (
  <SvgIcon viewBox="0 0 20 18" style={props.style}>
    <defs>
      <path fill={props.color} d="M15 11.75v4.5h3a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25zm-6-10v4.5h9a.25.25 0 0 0 .25-.25V2a.25.25 0 0 0-.25-.25zM2 .25h16c.966 0 1.75.784 1.75 1.75v4A1.75 1.75 0 0 1 18 7.75H2A1.75 1.75 0 0 1 .25 6V2C.25 1.034 1.034.25 2 .25zm0 10h16c.966 0 1.75.784 1.75 1.75v4A1.75 1.75 0 0 1 18 17.75H2A1.75 1.75 0 0 1 .25 16v-4c0-.966.784-1.75 1.75-1.75z" id="a" />
    </defs>
    <g fill={props.color} fillRule="evenodd">
      <mask id="b">
        <use href="#a" width="100%" height="100%" />
      </mask>
      <use href="#a" width="100%" height="100%" fillRule="nonzero" />
      <g mask="url(#b)">
        <path d="M-2-3h24v24H-2z" />
      </g>
    </g>
  </SvgIcon>
);

export default UsageLimits;



// WEBPACK FOOTER //
// ./src/icons/UsageLimits.jsx